/** Messages de connexion admin — pas de détail Firebase (énumération de comptes). */
export const GENERIC_LOGIN_ERROR = 'Identifiants incorrects ou accès refusé.';

/**
 * @param {{ code?: string; message?: string } | null | undefined} err
 * @returns {string} Message affichable ; chaîne vide = ne pas afficher d'alerte
 */
export function getAdminLoginErrorMessage(err) {
  if (!err) return GENERIC_LOGIN_ERROR;

  switch (err.code) {
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
    case 'auth/invalid-email':
      return GENERIC_LOGIN_ERROR;
    case 'auth/too-many-requests':
      return 'Trop de tentatives. Réessayez dans quelques minutes.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return '';
    case 'auth/popup-blocked':
      return 'La fenêtre de connexion a été bloquée. Autorisez les popups pour ce site.';
    case 'auth/account-exists-with-different-credential':
      return 'Ce compte est lié à une autre méthode de connexion.';
    default:
      break;
  }

  const message = typeof err.message === 'string' ? err.message.trim() : '';
  if (message && !message.startsWith('Firebase:')) {
    return message;
  }

  return GENERIC_LOGIN_ERROR;
}
